import React from 'react';
import './ErrorDisplay.scss';

export default function ErrorDisplay({ error, title = 'Fehler', className = '' }) {
  if (!error) return null;

  return (
    <div className={`error-display ${className}`}>
      <div className='error-display-icon'>
        <i className='dx-icon-warning'></i>
      </div>
      <div className='error-display-content'>
        <div className='error-display-title'>{title}</div>
        <div className='error-display-message'>{error}</div>
      </div>
    </div>
  );
}
